import React from 'react';
import { useTeamSuggestions } from '../hooks/useTeamSuggestions';
import {
  TeamSuggestionItem,
  TeamSuggestionItemProps
} from '@cube3/cubicle/src/core/molecules/SuggestionItems/TeamSuggestionItem';

export const TeamSuggestionItemRow = (props: TeamSuggestionItemProps) => {
  const { item, ...restProps } = props;

  const { members, loading } = useTeamSuggestions(item?.id);

  return (
    <TeamSuggestionItem
      item={item}
      members={members}
      loading={loading}
      {...restProps}
    />
  );
};
